import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogService } from 'src/app/dynamic-dialog/dynamic-dialog.service';
import { ToastGlobalService } from 'src/app/layout/toast-global/toast-global.service';
import { Actions } from 'src/app/models/actions';
import { DynamicTableInterface } from 'src/app/models/interface/dynamicTable';
import { VehicleMaintenance } from 'src/app/models/vehicleMaintenance';
import { VehicleSchedule } from 'src/app/models/vehicleSchedule';
import { VehicleService } from '../vehicle/service/vehicle.service';
import { MaintainVehicleMaintenance } from 'src/app/models/constant/right';
import { GenericValidators } from 'src/app/shared/generic-validators';
import { SpaRoutingService } from 'src/app/shared/services/spa.routing.service';

@Component({
    selector: 'app-vehicle-maintenance',
    templateUrl: './vehicle-maintenance.component.html',
    styleUrls: ['./vehicle-maintenance.component.css'],
    standalone: false
})
export class VehicleMaintenanceComponent implements OnInit, OnChanges, DynamicTableInterface {
  @Input() tenantId: string;
  @Input() vin: string;
  @Input() refreshMaintenances: number;
  @Output() public functionCallback = new EventEmitter();

  Actions: typeof Actions = Actions;
  loading = true;
  vehicleMaintenance: VehicleMaintenance[];
  dataSource = new MatTableDataSource<any>();
  matSortActive = '';
  baseSort = 'completionDate: -1';
  private currentSort = `{${this.baseSort}}`;


  private currentFilter = '{}';
  private currentOffset = 0;
  private currentLimit = 10;
  includeSelect = true;

  searchString = `{$or: [
    {"part.partNumber": /|replaceText|/i},
    {"vehicleScheduleName": /|replaceText|/i},
    {"action": /|replaceText|/i},
    {"createdBy": /|replaceText|/i},
    {"updatedBy": /|replaceText|/i},
    {"notes": /|replaceText|/i}
  ]}`;

  gridDisplayColumns = [
    {
      display: '@complete',
      property: 'isComplete',
      type: 'boolean'
    },
    {
      display: '@schedule',
      property: 'vehicleScheduleName',
      type: 'text'
    },
    {
      display: '@action',
      property: 'action',
      type: 'action'
    },
    {
      display: '@partNumber',
      property: 'partNumber',
      type: 'text',
      hidden: true
    },
    {
      display: '@createBy',
      property: 'createdBy',
      type: 'text',
      hidden: true
    },
    {
      display: '@completedDate',
      property: 'completionDate',
      type: 'date'
    },
    {
      display: '@updatedBy',
      property: 'updatedBy'
    },
    {
      display: '@notes',
      property: 'notes',
      type: 'text',
      hidden: true
    }
  ];
  tableFunctions = [
    {
      display: '@completeMaintenance',
      action: 'completeMaintenance',
      icon: 'fa fa-wrench',
      validators: (rows) => this.validators.selectedLengthValidator(rows, ">=", 1),
      requireRight: () => this.validators.hasRight(MaintainVehicleMaintenance)
    },
    {
      display: '@createNewMaintenance',
      action: 'add',
      icon: 'fa fa-plus',
      validators: (rows) => this.validators.notSelectedValidator(rows),
      requireRight: () => this.validators.hasRight(MaintainVehicleMaintenance)
    },
    {
      display: '@showAllColumns',
      action: 'show',
      icon: 'fa fa-eye'
    }
  ];
  length: number;

  constructor(
    private vehicleService: VehicleService,
    private router: Router,
    private toastGlobalService: ToastGlobalService,
    private dialogService: DynamicDialogService,
    private translate: TranslateService,
    private validators: GenericValidators,
    private spaRoutingService: SpaRoutingService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.refreshMaintenances && !changes.refreshMaintenances.firstChange) {
      this.getData(
        this.currentOffset,
        this.currentLimit,
        this.currentFilter,
        this.currentSort
      );
    }
  }

  getData(offset: number, limit: number, filter: string, sort: string): void {
    this.loading = true;
    const promises = [];
    const vmp = this.vehicleService.getVehicleMaintenance(this.vin, filter, sort, offset, limit)
      .toPromise()
      .then(res => {
        this.dataSource = new MatTableDataSource(res.documents);
        this.length = res.count;

      });
    promises.push(vmp);

    Promise.all(promises)
      .then(res => {
        this.loading = false;
        this.dataSource.data.forEach(m => {
          if (m.state.isComplete === 'true') {
            m.completeDate = m.date.completeDate;
            m.isComplete = true;
          } else {
            m.isComplete = false;
          }
        });
      });
  }

  pageChangedEvent(event): void {
    const pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    this.currentLimit = pageSize;
    const previousSize = pageSize * pageIndex;
    this.currentOffset = previousSize;
    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort
    );
  }

  filterChanged(filterList: string): void {
    this.currentFilter = filterList;
    this.currentOffset = 0;

    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort);
  }

  sortDataEvent(sort: string): void {
    this.currentSort = sort;
    this.currentOffset = 0;
    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort);
  }

  selectRowEvent(event: any): void {
    this.vehicleService.selectedMaintenance = event.row;
    this.spaRoutingService.navigateToVehicleMaintenance(this.vin, this.vehicleService.selectedMaintenance.id);
  }

  refreshDataEvent(event: any): void {
    const pageIndex = event.pageIndex;
    const pageSize = event.pageSize;
    this.currentLimit = pageSize;
    const previousSize = pageSize * pageIndex;
    this.currentOffset = previousSize;
    this.currentFilter = event.filter;
    this.currentSort = event.sortString;
    this.getData(
      this.currentOffset,
      this.currentLimit,
      this.currentFilter,
      this.currentSort
    );

    this.toggleShowColumns(event.showAllColumns);

  }

  toggleShowColumns(showAllColumn: boolean): void {
    this.gridDisplayColumns.forEach(col => {
      if (showAllColumn) {
        if (col.hidden === true) {
          col.hidden = false;
        }
      }
      else {
        if (col.hidden === false) {
          col.hidden = true;
        }
      }
    });
  }

  processFunction(event: any): void {
    switch (event.action) {
      case 'navigate':
        this.selectRowEvent(event);
        break;
      case 'page':
        this.pageChangedEvent(event);
        break;
      case 'filter':
        this.filterChanged(event.filter);
        break;
      case 'sort':
        this.sortDataEvent(event.sort);
        break;
      case 'refresh':
        this.refreshDataEvent(event);
        break;
      case 'show':
        this.toggleShowColumns(event.showAllColumns);
        break;
      case 'add':
        this.spaRoutingService.navigateToVehicleMaintenance(this.vin);
        break;
      case 'completeMaintenance':
        const allSelected = event.allSelected;
        const rowsSelected = event.rowsSelected;
        this.completeMaintenance(allSelected, rowsSelected);
        break;
    }
  }

  completeMaintenance(allSelected: boolean, rowsSelected: any[]): void {
    if (!allSelected && rowsSelected.length < 1) {
      this.toastGlobalService.show('You must have at least one row selected.', { classname: 'error' });
    }
    else {
      const payload = {
        complete: true
      };

      this.dialogService.openAddMaintenanceDialog(payload).afterClosed().subscribe(res => {
        if (res) {
          this.vehicleService.updateMaintenances(
            rowsSelected,
            res.currentSelected,
            res.currentDate,
            res.hoursTaken).subscribe(ret => {
              const toast = this.translate.instant('Maintenance Completed');
              this.toastGlobalService.show(toast, { classname: 'success' });
              const newEvent = {
                action: 'refreshSchedules'
              };
              this.functionCallback.emit(newEvent);

              this.getData(
                this.currentOffset,
                this.currentLimit,
                this.currentFilter,
                this.currentSort
              );
            });
        }
      });
    }
  }
}
